import axios from './axiosConfig';

export const submitSurvey = async (collectionType, surveyAnswers) => {
  if (collectionType === 'Marketing') collectionType = 'Social';
  const url = '/fs/surveys/create';
  const payload = {
    surveyAnswers,
    collectionType,
  };
  const { data } = await axios.post(url, payload);
  return data;
};

export const deleteSurvey = async (collectionType, surveyId) => {
  if (collectionType === 'Marketing') collectionType = 'Social';
  const url = '/fs/surveys/delete';
  const payload = {
    collectionType,
    surveyId,
  };

  const { data } = await axios.delete(url, { data: payload });

  return data;
};

export const updateSurvey = async (collectionType, surveyId, updatedSurveyData) => {
  if (collectionType === 'Marketing') collectionType = 'Social';
  const url = '/fs/surveys/edit';
  const payload = {
    collectionType,
    surveyId,
    updatedSurveyData,
  };

  const { data } = await axios.put(url, payload);

  return data;
};

export const changeUserAgency = async (userEmail, targetAgencyUserEmail) => {
  const url = '/fs/change-user-agency';
  const payload = {
    userEmail,
    targetAgencyUserEmail,
  };
  const { data } = await axios.post(url, payload);
  return data;
};

export const assignAgencyToCompany = async (userEmail, targetAgencyUserEmail) => {
  const url = '/fs/assign-agency-to-company';
  const payload = {
    userEmail,
    targetAgencyUserEmail,
  };
  const { data } = await axios.post(url, payload);
  return data;
};

export const changeUserDisplayName = async (userEmail, newDisplayName) => {
  const url = '/fs/change-user-display-name';
  const payload = {
    userEmail,
    newDisplayName,
  };
  const { data } = await axios.post(url, payload);
  return data;
};

export const AITextGenerator = (brandName, contentType, platform, title, keyword1, keyword2, keyword3) => {
  return new Promise((resolve, reject) => {
    const url = '/ai/marketing-content-content';
    const data = { brandName, contentType, platform, title, keyword1, keyword2, keyword3 };
    axios
      .post(url, data)
      .then(response => {
        if (!response.data.error) {
          resolve(response.data.result);
        } else {
          reject('An error occurred while calulcating the data');
        }
      })
      .catch(err => {
        console.log(err);
        reject('An error occurred while generating AI post');
      });
  });
};

export const AIProductSocialCausesAnswerGenerator = async (Post_Category, postText) => {
  try {
    const productUrl = '/ai/product-clasify';
    const socialUrl = '/ai/social-and-causes-clasify';

    // Category 1 → Product only
    if (Post_Category == 1) {
      const res = await axios.post(productUrl, { postText });
      if (res.data.error) throw new Error();
      return res.data.result;
    }

    // Category 3,4,5 → Social only
    if ([3, 4, 5].includes(Number(Post_Category))) {
      const res = await axios.post(socialUrl, { postText });
      if (res.data.error) throw new Error();
      return res.data.result;
    }

    // Category 2 → Both
    if (Post_Category == 2) {
      const [productRes, socialRes] = await Promise.all([
        axios.post(productUrl, { postText }),
        axios.post(socialUrl, { postText }),
      ]);

      if (productRes.data.error || socialRes.data.error) {
        throw new Error();
      }

      // Merge results
      return {
        ...productRes.data.result,
        ...socialRes.data.result,
      };
    }

    throw new Error('Invalid data');
  } catch (err) {
    throw new Error('An error occurred while processing');
  }
};

const updateSocialPostMarketingStrategy = async (socialPostID, brandPersonaID, newStrategy, oldStrategies) => {
  try {
    if (typeof oldStrategies === 'undefined') oldStrategies = {};
    const newData = {
      marketingStrategies: {
        ...oldStrategies,
        [brandPersonaID]: newStrategy,
      },
    };

    const response = await updateSurvey('social', socialPostID, newData);
    if (!response.err) {
      return {
        err: false,
        errMessage: '',
      };
    } else {
      return {
        err: true,
        errMessage: response.errMessage,
      };
    }
  } catch (err) {
    return {
      err: true,
      errMessage: err.message,
    };
  }
};

export const AISocialMediaStrategyGenerator = (data, socialPostPickedId, brandPersonaPickedId, marketingStrategies) => {
  return new Promise((resolve, reject) => {
    const url = '/ai/marketing-content-strategy';
    axios
      .post(url, data)
      .then(response => {
        if (!response.data.error) {
          updateSocialPostMarketingStrategy(
            socialPostPickedId,
            brandPersonaPickedId,
            response.data.result,
            marketingStrategies,
          )
            .then(res => {
              if (!res.err) {
                resolve(response.data.result);
              } else {
                console.log(res.errMessage);
                reject('An error occurred while trying to save marketing strategy.');
              }
            })
            .catch(err => {
              console.log(err.message);
              reject('An error occurred while trying to save marketing strategy.');
            });
        } else {
          reject('An error occurred while calulcating the data');
        }
      })
      .catch(err => {
        console.log(err);
        reject('An error occurred while generating AI strategy');
      });
  });
};

export const checkAuthState_API = async () => {
  const response = await axios.get('/auth/check');
  return response;
};

export const AIChatBot = messages => {
  return new Promise((resolve, reject) => {
    const url = '/ai/chat-ask';
    const data = { messages };
    axios
      .post(url, data)
      .then(response => {
        if (!response.data.error) {
          resolve(response.data.result);
        } else {
          reject('An error occurred while generating response');
        }
      })
      .catch(err => {
        reject('An error occurred while connecting to the chat assistant');
      });
  });
};
